export default "__VITE_ASSET__1d4c25ca__"